// Lienzo del cheque: posiciona los campos en mm sobre el fondo del banco.
// Es el mismo elemento que se usa tanto en la vista previa de "Generar
// cheque" como en "Calibración".
export default function ChequeLienzo({ banco, calibracion, fecha, nombre, montoFormateado, montoTexto, id = 'cheque-lienzo' }) {
  if (!banco || !calibracion) return null;

  return (
    <div
      id={id}
      style={{
        width: `${banco.ancho_mm}mm`,
        height: `${banco.alto_mm}mm`,
        backgroundImage: banco.imagen_referencia ? `url(${banco.imagen_referencia})` : 'none',
      }}
      className={banco.imagen_referencia ? 'cheque-lienzo' : 'cheque-lienzo sin-imagen-referencia'}
    >
      <div className="cheque-element" style={{ fontSize: `${calibracion.fuente_pt}pt`, left: `${calibracion.fecha_x}mm`, top: `${calibracion.fecha_y}mm` }}>
        {fecha || 'Fecha…'}
      </div>
      <div className="cheque-element" style={{ fontSize: `${calibracion.fuente_pt}pt`, left: `${calibracion.nombre_x}mm`, top: `${calibracion.nombre_y}mm` }}>
        {nombre || 'NOMBRE BENEFICIARIO'}
      </div>
      <div className="cheque-element" style={{ fontSize: `${calibracion.fuente_pt}pt`, left: `${calibracion.monto_x}mm`, top: `${calibracion.monto_y}mm` }}>
        {montoFormateado}
      </div>
      <div
        className="cheque-element cheque-monto-texto"
        style={{
          fontSize: `${calibracion.fuente_pt}pt`,
          left: `${calibracion.texto_x}mm`,
          top: `${calibracion.texto_y}mm`,
          width: `${calibracion.texto_w}mm`,
        }}
      >
        {montoTexto}
      </div>
    </div>
  );
}
